var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.navStyle},[_c('TheNav')],1),_c('div',{class:_vm.bodyStyle},[_c('div',{class:_vm.$style.topBar},[_c('TheTopbar')],1),_c('div',{class:_vm.$style.view},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }